import * as d3 from 'd3'
export default {
  methods: {

    draw_Detail() {
      
      let detail = this.detail
      if(detail.visible !== 'Y') return

      let detailInfo = this.svg
      .append('g')
      .attr('id', 'DETAIL_CANVAS')
      .attr('transform', `translate(${detail.x}, ${detail.y})`)
      .attr('opacity', detail.onOff == 'ON' ? 1 : 0)

      this.gmx_groupBox(detailInfo, {
        x         : 0,
        y         : 0,
        width     : detail.width,
        height    : detail.height,
        label     : '',
        labelWidth: 0,
      })
      
      detailInfo
      .append('rect') // Fill Color
      .attr('x', 5).attr('y', -8)
      .attr('rx', 2).attr('ry', 2)
      .attr('width', detail.title.width).attr('height', 16)
      .attr('fill', '#F8FAFB').attr('fill-opacity', 1)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      detailInfo
      .append('text')
      .attr('id', `SKY_NO`)
      .attr('x', 5 + (detail.title.width/2)).attr('y', 4)
      .attr('font-size', 12).attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .text(this.rawData[0][this.codes.skyline])


      let y = 25
      detail.item.forEach(d=> {

        detailInfo
        .append('text')
        .attr('id', `DETAIL_${d.code}`)
        .attr('x', 10).attr('y', y)
        .attr('font-size', d.tSize).attr('fill', '#333')
        .attr('text-anchor', 'start')
        .text(d.name)

        d.tx = this.getNode(`#DETAIL_${d.code}`, 'width') + 15
        if(d.type == 'TEXT') this.detail_Text(detailInfo, d, d.tx+.5, y+.5)
        if(d.type == 'BAR') this.detail_Chart(detailInfo, d, 90.5, y+.5)

        y = y + detail.lineHeight
        if(d.code == 'DESC') y = y + 5
      })

    },


    detail_Text(selection, d, tx, y) {
      let value = this.rawData.filter(f => f[this.codes.timeline])[0][d.code]
      if(value) {
        selection
        .append('text')
        .attr('id', `TEXT_${d.code}`)
        .attr('x', tx-5).attr('y', y)
        .attr('font-size', d.tSize).attr('fill', d.tColor)
        .attr('text-anchor', 'start')
        .text((value.length > this.detail.trim) ? value.substr(0,this.detail.trim) + '...' : value)
      }
    },


    detail_Chart(selection, d, bx, y) {

      let data = this.rawData.filter(f => f[this.codes.timeline])

      selection // TOT
      .append('text')
      .attr('id', `TOT_${d.code}`)
      .attr('x', bx-2).attr('y', y)
      .attr('font-size', d.tSize).attr('fill', d.tColor)
      .attr('text-anchor', 'end')
      .text(data[0][`${d.code}_TOT`])

      let prog = data[0][`${d.code}_PRO`]

      selection
      .append('rect')
      .attr('id', `BACK_${d.code}`)
      .attr('x', bx).attr('y', y - 9.5)
      .attr('width', 100).attr('height', 12)
      .attr('fill', '#E0E0DF').attr('fill-opacity', .3)

      selection
      .append('rect')
      .attr('id', `BAR_${d.code}`)
      .attr('x', bx).attr('y', y - 9.5)
      .attr('width', prog).attr('height', 12).attr('fill', d.bColor)

      selection
      .append('text')
      .attr('id', `ACT_${d.code}`)
      .attr('x', prog > 70 ? bx+prog : bx+prog+2).attr('y', y)
      .attr('font-size', d.tSize).attr('fill', d.tColor)
      .attr('text-anchor', prog > 70 ? 'end' : 'start')
      .text(data[0][`${d.code}_ACT`])

      selection
      .append('text')
      .attr('id', `REM_${d.code}`)
      .attr('x', bx+100+2).attr('y', y)
      .attr('font-size', d.tSize - .5).attr('fill', d.tColor)
      .attr('text-anchor', 'start')
      .text(data[0][`${d.code}_REM`])
    },


    detail_Reflash(data) {

      if(this.detail.visible !== 'Y') return
      let bx = 90.5

      d3.select(`#SKY_NO`).text(data[this.codes.skyline])
      
      this.detail.item.forEach(d=> {
        if(d.type == 'TEXT') {
          let value = data[d.code]
          if(value) d3.select( `#TEXT_${d.code}`).text((value.length > this.detail.trim) ? value.substr(0,this.detail.trim) + '..' : value)
        }

        if(d.type == 'BAR') {
          let prog = data[`${d.code}_PRO`]
          this.gmx_textTween(`#TOT_${d.code}`, data[`${d.code}_TOT`], 150, null, null, null, null, null)

          d3.select( `#BAR_${d.code}`).transition().duration(150).attr('width', prog)
          this.gmx_textTween(`#ACT_${d.code}`, data[`${d.code}_ACT`], 150, null, prog > 70 ? bx+prog : bx+prog+2, null, null, prog > 70 ? 'end' : 'start')

          this.gmx_textTween(`#REM_${d.code}`, data[`${d.code}_REM`], 150, null, null, null, null, null)
        }
      })
    },

  }
}
